export enum CustomResponseHeader {
  XAuthExpires = 'x-auth-expires',
}
